import { useEffect } from 'react';

/**
 * Hook personalizado para manejar el click fuera del componente
 * @param ref - Referencia al elemento DOM
 * @param callback - Función a ejecutar cuando se hace click fuera
 */
export const useClickOutside = (
  ref: React.RefObject<HTMLElement>, 
  callback: () => void
) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [ref, callback]);
};